<template>
	<div class="confirmSms">
		<h2 class=instH2> Подтвердите номер телефона </h2>
		<div id="asdasdasd">
      <!-- <p> Мы отправили код подтверждения на ваш номер:<br class="mobileOnly"> ({{phoneVuex}})</p> -->
			<!-- <formInput :refs="'SmsConfCode'"></formInput> -->
			<instSmsInput :fieldName="'SmsConfCode'"></instSmsInput>
			<div>
				<a href="#" v-on:click="reSendCode" class="txtLink" v-if="timerCount <= 0">Отправить смс повторно</a>
				<p v-else>Повторно отправить код можно будет через {{ timerCount }} сек </p>
			</div>
		</div>
		<div class="asp" >
			<instCheckBox :fieldName="'ASP'"></instCheckBox>	
			<instCheckBox :fieldName="'AGREEMENT_KI_REQUEST'"></instCheckBox>	
      
		</div>
	</div>
</template>
<script>
import {mapState} from 'vuex';
export default {
	name: "confirmSms",
	data() {
		return {
			timerCount: 120,
		}
	},
	components: {
		// formInput:    () => import('@/views/pdlloan/formInput'),
		// formCheckBox: () => import('@/views/pdlloan/formCheckBox'),
		instCheckBox: () => import('@/components/inst/instCheckBox.vue'),
		instSmsInput: () => import('@/components/inst/instSmsInput.vue'),
	},
	mounted() {
		if (process.env.NODE_ENV !== 'development') {
			this.SMSConfirmationLid();
		} else {
			alert('dev run')
		}
	},
	methods: {
		SMSConfirmationLid(){
      // 2ECF4C25-852A-402D-8C30-3841CF5E9501
			this.$emit('scrollingTo', {
				id:'zform',
			});
			this.$external.consoleDebug('this.$external.run({action:SMSConfirmationLid then','open');
				this.$external.run({
					action: 'SMSConfirmationLid',
          PhoneNumber: this.phoneVuex,
				}).then((res)=>{
					try {
						if (res.ExecutionError.ExecutionErrorCode=== 0) {
							localStorage.setItem('ConfirmationGUID',res.ExecutionResult.ConfirmationGUID);
						} else {
							this.$store.dispatch('fieldError', {
								target: 'SmsConfCode',
								value: res.ExecutionError.ExecutionErrorMessage
							});
						}
					} catch (e) {

						this.$store.dispatch('fieldError', {
							target: 'SmsConfCode',
							value: 'Ошибка отправки смс, попробуйте позже sid=' + window.session_id
						});
					}

				}).catch((res)=>{
					this.$external.consoleDebug(res);
					this.$store.dispatch('fieldError', {
						target: 'SmsConfCode',
						value: 'Смс временно не может быть отправлена, попробуйте позже sid=' + window.session_id
					});
				}).finally(()=>{
					this.$external.consoleDebug('this.$external.run({action:SMSConfirmationLid then','close');
				});
		},
		reSendCode($event){
			$event.preventDefault();
			if (this.timerCount > 0) return false;
			this.timerCount = 120;
			this.$store.dispatch('saveSendData', { target: 'SmsConfCode', value: '' });
			this.SMSConfirmationLid();
		},
	},
	computed: {

		...mapState({
			ConfirmationCode: state => state.Form.sendData.SmsConfCode,
			phoneVuex:        state => state.Form.sendData.PHONE,
			aspVuex:       state => state.Form.workData.ASP,
		}),
	},
	watch: {
		timerCount: {
			handler(value) {
				if (value > 0) {
					setTimeout(() => { this.timerCount--; }, 1000);
				}
			},
			immediate: true
		}
	}
}
</script>
<style scoped>

.instH2{margin-top: 0;}
#asdasdasd{text-align: center;}
/* #anketaSteps > .confirmSms > h2 { margin-bottom: 1.94vw }
.asp > div{ margin-bottom: 3.53vw }
.confirmSms div p { line-height: 4.4vw; margin-bottom: 4.12vw }
.confirmSms div a { line-height: 2.40vw; color: #45b537 }
.canClick { color: #45b537;text-decoration: underline;cursor: pointer }
@media screen and (min-width: 760px) {
  #anketaSteps > .confirmSms > h2 { margin-bottom: 1.94vw }
	.confirmSms div p { line-height: normal; margin-bottom: 1.69vw}
	.confirmSms div a { line-height: normal; }
	.asp > div{ margin-bottom: 1.29vw; }
}
@media screen and (min-width: 760px) {
  #anketaSteps > .confirmSms > h2 { margin-bottom: 24px }
  .confirmSms div p { margin-bottom: 21px; font-size: 12px}
	.asp > div{margin-bottom: 16px  }
} */
</style>
